<template>
    <div>
        <h5-dialog>
            <div
                class="text-center w-100"
                style="margin-bottom:10px;font-size:18px;"
            >
                {{ registerType === 'mobile' ? $t('邮箱登录') : $t('账号注册') }}
            </div>
            <div class="form">
                <template v-if="registerType === 'mobile'">
                    <div style="margin-bottom:5px;">
                        <h5-input v-model="registerFrom.mobile" :placeholder="$t('请输入邮箱')">
                            <template v-slot:prepend>
                                <i class="fa fa-mobile" style="font-size:22px;color:#f9dda0;" />
                            </template>
                        </h5-input>
                    </div>
                    <div style="margin-bottom:8px;">
                        <verify-code :mobile="registerFrom.mobile" v-model="registerFrom.code"></verify-code>
                    </div>
                </template>
                <template v-else>
                    <div style="margin-bottom:5px;">
                        <h5-input v-model="registerFrom.account" :placeholder="$t('请输入账号')">
                            <template v-slot:prepend>
                                <i class="fa fa-user-o" style="font-size:16px;color:#f9dda0;" />
                            </template>
                        </h5-input>
                    </div>
                    <div style="margin-bottom:8px;">
                        <h5-input
                            v-model="registerFrom.password"
                            :placeholder="$t('请输入密码')"
                            :type="passwordVisible ? 'text' : 'password'"
                        >
                            <template v-slot:prepend>
                                <i class="fa fa-lock" style="font-size:18px;color:#f9dda0;" />
                            </template>
                            <template v-slot:append>
                                <i
                                    class="fa password-visible-icon"
                                    :class="[passwordVisible ? 'fa-eye' : 'fa-eye-slash']"
                                    @click="passwordVisible = !passwordVisible"
                                />
                            </template>
                        </h5-input>
                    </div>
                </template>
                <div class="to-center">
                    <label class="flex-row flex-center">
                        <span style="color:#999;font-size:12px;" v-if="isShowPrivacy">
                            《
                            <a style="text-decoration:underline;" @click="showUserAgreement = true">{{ $t('隐私协议') }}</a>
                            》
                        </span>
                        <span style="color:#999;font-size:12px;margin-left:6px;" v-if="isShowTermsOfService">
                            《
                            <a style="text-decoration:underline;" @click="showTermsOfService = true">{{ $t('服务条款') }}</a>
                            》
                        </span>
                    </label>
                </div>
            </div>
            <button
                class="btn btn-block btn-primary m-b"
                @click="handleRegistration"
                style="border-radius:18px;margin-top:8px;"
            >
                {{ registerType === 'mobile' ? $t('登录') : $t('注册') }}
            </button>
            <van-row>
                <van-col span="12" class="to-center">
                    <div
                        v-if="registerType === 'account'"
                        class="bottom-button"
                        @click="changeRegType('mobile')"
                    >
                        {{ registerType === 'mobile' ? $t('账号登录') : $t('邮箱登录') }}
                    </div>
                    <router-link
                        v-else
                        :to="{
                            path: '/login',
                            query: { ...$route.query }
                        }"
                        class="bottom-button"
                    >
                        {{ registerType === 'mobile' ? $t('账号登录') : $t('邮箱登录') }}
                    </router-link>
                </van-col>
                <van-col span="12" class="to-center">
                    <div
                        v-if="registerType === 'mobile'"
                        class="bottom-button"
                        @click="changeRegType('account')"
                    >
                        {{ registerType === 'mobile' ? $t('账号注册') : $t('账号登录') }}
                    </div>
                    <router-link
                        v-else
                        :to="{
                            path: '/login',
                            query: { ...$route.query }
                        }"
                        class="bottom-button"
                    >
                        {{ registerType === 'mobile' ? $t('账号注册') : $t('账号登录') }}
                    </router-link>
                </van-col>
            </van-row>

            <div v-if="isShowGoogleLogin">
                <div class="empty-element" />

                <div id="g_id_onload"
                    data-client_id="799433220452-qb54b5us8joeusrb62cvqlf2hnf469eb.apps.googleusercontent.com"
                    data-callback="handleCredentialResponse"
                    data-context="signin">
                </div>

                <div class="g_id_signin"
                    data-type="standard"
                    data-shape="rectangular"
                    data-theme="outline"
                    data-text="signin_with"
                    data-size="large">
                </div>
            </div>

            <div class="oversea">
                <!-- <div class="facebook" @click="loginWithFacebook">
                    <i class="fa fa-facebook-square" style="font-size:22px;color:#3975ea;" />
                    <span>Login</span>
                </div> -->
                <div class="google" @click="loginWithGoogle" v-if="showGoogleLoginByAndroid">
                    <i class="fa fa-google" style="font-size:22px;color:#d14e3d;" />
                    <span>Login</span>
                </div>
            </div>
            <div class="serviceQQ bottom-button">
                <span @click="serviceActivated = true">
                    {{ $t('联系客服') }}
                </span>
            </div>
        </h5-dialog>


        <!-- 用户协议组件 -->
        <user-agreement v-if="showUserAgreement" @agree="handleAgree"></user-agreement>

        <!-- 服务条款组件（game_id=1123039 / 1123038 显示入口） -->
        <terms-of-service v-if="showTermsOfService" @close="showTermsOfService = false"></terms-of-service>


        <bind-id-card
            :closable="bindIDCardClosable"
            :loginOutable="bindIDCardLoginOutable"
            v-if="showBindIDCard"
            @close="onBindIDClose"
            @bind-success="onBindIDSuccess"
            @close-bind-id-modal="closeBindIDModal"
        ></bind-id-card>

        <van-dialog
            v-model="serviceActivated"
            :title="$t('联系客服')"
        >
            <div class="text-center">
                <div class="m-b text-center">
                    <div class="m-b-sm">
                        If you have any questions, please contact our customer service email, and we will get back to you as soon as possible.
                    </div>
                    <h3>Email: xhskyxgs@gmail.com</h3>
                </div>
            </div>
        </van-dialog>

        <!-- <van-dialog
            v-model="serviceActivated"
            :title="serviceData.title || $t('联系客服')"
            show-cancel-button
            :cancel-button-text="$t('关闭')"
            :confirm-button-text="$t('立即联系')"
            @confirm="addServiceQQ"
        >
            <div class="text-center">
                <div class="m-b text-center">
                    <div class="m-b-sm" v-show="serviceData.describe">{{ serviceData.describe }}</div>
                    <div class="m-b-sm" v-show="serviceData.title">{{ serviceData.title }}</div>
                    <h3 v-show="serviceData.qq">QQ：{{ serviceData.qq }}</h3>
                    <h3 v-show="serviceData.phone">{{ $t('邮箱') }}：{{ serviceData.phone }}</h3>
                    <small>{{ $t('时间') }}：{{ serviceData.service_time || '-' }}</small>
                    <h5>({{ $t('点击“立即联系”无反应，请手动添加QQ') }})</h5>
                </div>
            </div>
        </van-dialog> -->
    </div>
</template>

<script>
import { mapState } from 'vuex'
import H5Dialog from '@/components/H5Dialog'
import H5Input from '@/components/H5Input'
import VerifyCode from '@/components/VerifyCode'
import { getAccounts, setAccounts, setLastLoginAccount } from '@/utils/storage'
import verifyIDMixin from '@/mixins/verifyID.mixin'
import { Row, Col, Dialog, Dialog as VanDialog } from 'vant'
import browser from '@/utils/browser'
import { $t } from '@/utils/languages'

const spaceReg = /\s/g

export default {
    name: 'Register',
    mixins: [verifyIDMixin],
    components: {
        VerifyCode,
        UserAgreement: () => import(/* webpackChunkName: 'UserAgreement' */'../components/UserAgreement'),
        TermsOfService: () => import(/* webpackChunkName: 'TermsOfService' */'../components/terms/TermsOfService'),
        H5Input,
        H5Dialog,
        // VanCheckbox: Checkbox,
        VanRow: Row,
        VanCol: Col,
        VanDialog: VanDialog.Component,
    },
    data() {
        return {
            registerType: 'mobile', // mobile account
            registerFrom: {
                account: '',
                password: '',
                mobile: '',
                code: '',
                agreed: browser.isAndroid ? false : true, // 2022.07.25 安卓默认不同意，其他默认同意
            },
            localAccounts: {},
            showUserAgreement: false,
            showTermsOfService: false, // 是否显示服务条款
            prevRegType: '',
            registering: false,
            passwordVisible: false, // 是否显示密码
            serviceActivated: false,
        }
    },
    computed: {
        ...mapState({
            appConfig: state => state.app.appConfig,
            originQuery: state => state.app.originQuery,
            accountFirst: state => state.app.accountFirst,
            passwordFirst: state => state.app.passwordFirst,
            serviceData: state => state.serviceInfo,
        }),
        isShowPrivacy() {
            return ['1123005', '1123023', '1123026', '1123038', '1123039'].includes(`${this.appConfig.game_id}`)
        },
        isShowTermsOfService() {
            // 服务条款对 game_id=1123039（34包）和 game_id=1123038（谷歌6包）展示
            return ['1123038', '1123039'].includes(`${this.appConfig.game_id}`)
        },
        isShowGoogleLogin() {
            return ['1123001'].includes(`${this.appConfig.game_id}`)
        },
        showGoogleLoginByAndroid() {
            return window?.JsJingYouNativeBridge?.nativeLoginOfGoogle instanceof Function
        }
    },
    watch: {
        accountFirst: {
            handler(newAccount) {
                // 2022.01.18 首次注册时，用系统自动生成的名字
                this.registerFrom.account = newAccount
            },
            immediate: true,
        },
        passwordFirst: {
            handler(newPassword) {
                // 2022.01.18 首次注册时，用系统自动生成的密码
                this.registerFrom.password = newPassword
            },
            immediate: true,
        },
    },
    methods: {
        postAndroidLoginSuccess(prm) {
            try {
                // 2025.05.09 回传新安卓壳包登录信息
                const params = JSON.stringify({
                    userName: prm.username ?? '',
                    user_token: prm.user_token ?? '',
                })
                window?.JsJingYouNativeBridge?.loginSuccess?.(params)
                console.log('JsJingYouNativeBridge.loginSuccess<Android> | loginSuccess >>> ', params)
            } catch (err) {
                console.error('>>> post Android loginSuccess fail', err)
            }
        },
        postIosRegisterSuccess(prm) {
            try {
                // 2025.09.14 回传ios - 注册
                const iosRoleInfo = JSON.stringify({ ...prm })
                window?.webkit?.messageHandlers?.ios_appleregister?.postMessage?.(iosRoleInfo)
                console.log('webkit.messageHandlers<ios> | ios_appleregister.postMessage >>> ', iosRoleInfo)
            } catch (err) {
                console.error('>>> post ios register fail', err)
            }
        },
        async handleRegistration() {
            let regData = {}
            let api = 'userLogin'
            console.log('registerType', this.registerType)
            if (this.registerType === 'mobile') {
                if (this.registerFrom.mobile === '') {
                    this.$toast($t('请输入邮箱'))
                    return false
                }
                if (this.registerFrom.code === '') {
                    this.$toast($t('请输入验证码'))
                    return false
                }
                // if (!this.registerFrom.agreed) {
                //     this.$toast('请阅读并同意用户协议及隐私政策')
                //     return false
                // }
                let genAccount = await this.$store.dispatch('generateAccount')
                console.log('genAccount', genAccount)
                regData = {
                    check_type: 4, // 邮箱登录传4
                    email: this.registerFrom.mobile,
                    code: this.registerFrom.code,
                    user_sign: genAccount.account,
                    username: genAccount.account,
                    password: genAccount.password,
                    reg_type: 'mobile',
                }
                this.$toast.loading({
                    message: `${$t('登录中')}...`,
                    duration: 0,
                    closeOnClick: false,
                })
                api = 'userLogin'
            } else {
                if (this.registerFrom.account === '') {
                    if (this.registerType === 'mobile') {
                        this.$toast($t('请输入邮箱'))
                    } else if (this.registerType === 'account') {
                        this.$toast($t('请输入账号'))
                    } else {
                        this.$toast($t('请填写完整'))
                    }
                    return false
                } else {
                    if (spaceReg.test(this.registerFrom.account)) {
                        this.$toast($t('账号名不能带空格'))
                        return false
                    } else if (this.registerFrom.account.length > 10) {
                        this.$toast($t('请输入长度10位以内的账号名'))
                        return false
                    }
                }
                if (this.registerFrom.password === '') {
                    this.$toast($t('请输入密码'))
                    return false
                }
                // if (!this.registerFrom.agreed) {
                //     this.$toast('请阅读并同意用户协议及隐私政策')
                //     return false
                // }
                regData = {
                    username: this.registerFrom.account,
                    password: this.registerFrom.password,
                    reg_type: 'account',
                }
                this.$toast.loading({
                    message: `${$t('注册中')}...`,
                    duration: 0,
                    closeOnClick: false,
                })
                api = 'userRegister'
            }
            // if (!this.registerFrom.agreed) {
            //     // this.registerFrom.agreed = true
            //     this.$toast('请先同意用户协议及隐私政策')
            //     return false
            // }
            this.registering = true
            let accountData = {
                account: this.registerFrom.account,
                password: this.registerFrom.password,
            }
            this.$store.dispatch(api, regData).then(res => {
                this.$toast.clear()
                if (Number(res.code) === 0) {
                    // 2022.01.18 首次注册成功后，清空原有账号密码
                    this.$store.commit('app/UPDATE_ACCOUNT_FIRST', '')
                    this.$store.commit('app/UPDATE_PASSWORD_FIRST', '')

                    if (this.registerType === 'account') {
                        this.saveAccount(accountData)
                        setLastLoginAccount(accountData)
                    }else{
                        accountData = {
                            account: this.registerFrom.mobile,
                            password: '',
                        }
                        this.saveAccount({accountData})
                        setLastLoginAccount(accountData)
                    }
                    this.postAndroidLoginSuccess({ ...res.data })
                    this.postIosRegisterSuccess({ ...res.data })
                    this.$store.dispatch('saveAccountData', {
                        ...res.data,
                    }).then(() => {
                        this.updateVerifyInfo(res).then(() => {
                            // if(res.data.anti_time === 0){
                            //     this.$dialog.alert({
                            //         title: '提示',
                            //         message: `${res.data.anti_msg}`,
                            //         confirmButtonText: '确定',
                            //     })
                            // }else{
                                this.$toast.success($t('登录成功'))
                                console.log('redirectGame')
                                this.redirectGame()
                            // }
                        })
                    })
                } else {
                    this.$toast.fail(res.msg || $t('登录失败'))
                }
            }).finally(() => {
                this.registering = false
            })
        },
        getLocalAccounts() {
            if (typeof getAccounts() === 'object') {
                getAccounts().forEach(item => {
                    if (item.account) {
                        this.$set(this.localAccounts, item.account, item)
                    }
                })
            }
        },
        saveAccount(account) {
            if (account.account) {
                this.$set(this.localAccounts, `${account.account}`, account)
                setAccounts(Object.values(this.localAccounts))
            }
        },
        redirectGame() {
            this.$store.dispatch('checkGameUrl') // 2022.05.18 先检测新旧用户，再创建游戏
        },
        handleAgree() {
            this.registerFrom.agreed = true
            this.showUserAgreement = false
        },
        changeRegType(type) {
            this.prevRegType = type
            this.registerType = type
            this.registerFrom = {
                ...this.registerFrom, // 2022.01.18 注意此处不要置空 vuex中的账号、密码
                mobile: '',
                code: '',
                agreed: browser.isAndroid ? false : true, // 2022.07.25 安卓默认不同意，其他默认同意
            }
        },
        handleNavBack() {
            if (this.prevRegType) {
                this.registerType = (this.prevRegType === 'mobile' ? 'account' : 'mobile')
                this.prevRegType = ''
            } else {
                const query = { ...this.originQuery, ...this.$route.query }
                delete query.reg_type
                this.$router.replace({
                    path: '/login',
                    query,
                })
            }
        },
        // 加客服qq
        addServiceQQ() {
            const groupLink = this.serviceData.qq_url
            this.$dialog({ title: $t('正在尝试跳转QQ') })
            // 2022.05.27 iOS新壳包跳转方式（game_id: 1112004）
            if (window?.webkit?.messageHandlers?.ios_jumpstore?.postMessage) {
                window.webkit.messageHandlers.ios_jumpstore.postMessage(groupLink)
            } else {
                const tempFrame = document.createElement('iframe')
                tempFrame.setAttribute('frameborder', '0')
                tempFrame.setAttribute('src', groupLink)
                tempFrame.setAttribute('style', 'visibility: hidden;z-index: 0')
                tempFrame.onload = () => {
                    setTimeout(() => {
                        document.body.removeChild(tempFrame)
                        Dialog.close()
                    }, 2000)
                }
                tempFrame.onerror = () => {}
                document.body.appendChild(tempFrame)
            }
        },
        handleLoginSuccess(res) {
            const accountData = {
                account: this.registerFrom.account,
                password: this.registerFrom.password,
            }
            this.saveAccount(accountData)
            setLastLoginAccount(accountData)
            this.postAndroidLoginSuccess({ ...res.data })
            return this.$store.dispatch('saveAccountData', {
                ...res.data,
            }).then(() => {
                return this.updateVerifyInfo(res).then(() => {
                    const accountData = {
                        account: this.registerFrom.account,
                        password: this.registerFrom.password,
                    }
                    this.saveAccount(accountData)
                    setLastLoginAccount(accountData)
                    return this.$store.dispatch('saveAccountData', {
                        ...res.data,
                        ...accountData,
                    })
                }).catch(() => {
                    this.$toast('实名认证失败，请重试')
                    return Promise.reject({
                        msg: '实名认证失败',
                    })
                })
            })
        },
        // 动态加载Google登录脚本
        loadGoogleScript() {
            const script = document.createElement('script');
            script.src = 'https://accounts.google.com/gsi/client';
            script.async = true;
            script.defer = true;
            document.head.appendChild(script);
        },
        handleCredentialResponse(response) {
            console.log('>>> register/google  response', response)
            let { appConfig } = this
            if (!this.logining) {
                this.logining = true
                this.$toast.loading({
                    message: `${$t('注册中')}...`,
                    forbidClick: true,
                    duration: 0,
                })
                let loginData = {
                    access_token: response?.credential,
                    game_id: appConfig.game_id,
                }
                this.$store.dispatch('googleLogin', loginData).then(res => {
                    if (Number(res.code) === 0) {
                        this.$toast.clear()
                        this.handleLoginSuccess(res).then(() => {
                            this.$toast.success($t('登录成功'))
                            this.redirectGame()
                        })
                    } else {
                        this.$toast(res.msg || $t('登录失败'))
                    }
                }).finally(() => {
                    this.logining = false
                })
            }
        },
        // 安卓壳包谷歌登录
        loginWithGoogle() {
            // 拉起安卓壳包的谷歌登录
            try {
                window?.JsJingYouNativeBridge?.nativeLoginOfGoogle?.()
                console.log('JsJingYouNativeBridge.nativeLoginOfGoogle<Android> | nativeLoginOfGoogle >>> ')
            } catch (err) {
                console.error('>>> post Android nativeLoginOfGoogle fail', err)
            }
        },
        googleLoginByJhSdk(credential) {
            console.log('>>> google credential', credential)
            let { appConfig } = this
            if (credential && !this.logining) {
                this.logining = true
                this.$toast.loading({
                    message: `${$t('登录中')}...`,
                    forbidClick: true,
                    duration: 0,
                })
                let loginData = {
                    access_token: credential,
                    game_id: appConfig.game_id,
                }
                this.$store.dispatch('googleLogin', loginData).then(res => {
                    if (Number(res.code) === 0) {
                        this.$toast.clear()
                        this.handleLoginSuccess(res).then(() => {
                            this.$toast.success($t('登录成功'))
                            this.redirectGame()
                        })
                    } else {
                        this.$toast(res.msg || $t('登录失败'))
                    }
                }).finally(() => {
                    this.logining = false
                })
            }
        }
    },
    mounted() {
        if (this.isShowGoogleLogin) {
            this.loadGoogleScript()
            window.handleCredentialResponse = this.handleCredentialResponse
        }
        window.googleLoginByJhSdk = this.googleLoginByJhSdk // 安卓壳包谷歌登录成功后触发
        this.getLocalAccounts()
        this.changeRegType(this.$route.query.reg_type || 'mobile')
        this.prevRegType = ''
    },
}
</script>

<style lang="scss" scoped>
.nav-back-btn {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    /*height: max-content;*/
    width: 32px;
    height: 32px;
    line-height: 32px;
    margin: auto;
}

.serviceQQ {
    text-align: center;
    font-size: 14px;
    margin: 12px 0;
    cursor: pointer;
}

.oversea {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 18vw;
    margin-top: 6px;
    .facebook {
        display: inline-block;
        font-size: 16px;
        font-weight: bold;
        color: #3975ea;
        span {
            margin-left: 4px;
        }
    }
    .google {
        display: inline-block;
        font-size: 16px;
        font-weight: bold;
        color: #d14e3d;
        span {
            margin-left: 4px;
        }
    }
}

.empty-element {
    height: 16px;
}
</style>
